import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-permit-renewal.component.scss';
var FormItemPermitRenewal = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemPermitRenewal, _super);
    function FormItemPermitRenewal(element) {
        return _super.call(this, element) || this;
    }
    FormItemPermitRenewal.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        this.applyFormRadio = Array.from(this.element.querySelectorAll(".js-identification_radio--group"));
        this.expiryDate = this.element.querySelector('.js-date-picker-full');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displayMessage = this.form.querySelector(".form-container__message");
            this.displayMessageFail = this.form.querySelector(".form-container__message-fail");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
        }
        // inputs
        this.documentType = this.element.querySelector(".js-apply-now-doc-type");
        this.businessFields = Array.from(this.element.querySelectorAll(".js-bl-apply-now__visible-business"));
        this.southAfricanIdField = this.element.querySelector(".js-bl-apply-now__visible-id");
        // buttons
        this.buttonConfirmCustomer = this.form.querySelector(".js-blApplyPc__button--confirmCustomer");
        this.buttonSubmit = Array.from(this.element.querySelectorAll(".js-permitRenewal__button--submit"));
        // hidden
        this.hidLeadId = this.form.querySelector("input[name=leadId]");
        this.hidProduct = this.form.querySelector("input[name=product]");
        this.valuesJson = {
            dateEstablished: '',
        };
    };
    FormItemPermitRenewal.prototype.bindEvents = function () {
        var _this = this;
        this.applyFormRadio.map(function (item) { return item.addEventListener("click", function (event) {
            var evt = event.target;
            var identificationField = _this.form.querySelector("input[name=identification]");
            var identificationType = evt.value;
            var idTypeField = _this.form.querySelector("input[name=idType]");
            if (identificationType === "said") {
                identificationField.classList.remove("form__input--identification--passport");
                identificationField.classList.add("form__input--identification");
                identificationField.placeholder = "Enter your South Africa ID number";
                identificationField.type = "number";
                idTypeField.value = "IDENTITY";
            }
            else {
                identificationField.classList.remove("form__input--identification");
                identificationField.classList.add("form__input--identification--passport");
                identificationField.placeholder = "Enter your Passport number";
                identificationField.type = "text";
                idTypeField.value = "PASSPORT";
            }
        }); });
        this.expiryDate.addEventListener('keyup', function (event) {
            var element = event.target;
            if (element.value) {
                _this.valuesJson.dateEstablished = element.value;
            }
        });
        // change - date of company
        this.expiryDate.addEventListener('change', function (event) {
            var element = event.target;
            if (element.value) {
                _this.valuesJson.dateEstablished = element.value;
            }
        });
        if (this.buttonSubmit) {
            this.buttonSubmit.map(function (item) { return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            }); });
        }
        if (this.buttonConfirmCustomer) {
            this.buttonConfirmCustomer.addEventListener("click", function (event) {
                var _confirmed = _this.displayMessage.querySelector("input[name=customer-confirm]:checked");
                _this.showDisplayView("fields");
            });
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            // This will reset step 2
            _this.form.reset();
            _this.showDisplayView("");
        }, false);
    };
    FormItemPermitRenewal.prototype.submitForm = function (form) {
        var _this = this;
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        // Parameters
        var firstName = this.form.querySelector("input[name=first-name]");
        var surName = this.form.querySelector("input[name=last-name]");
        var id = form.querySelector("input[name=identification]");
        var contact = this.form.querySelector("input[name=phone-number]");
        var emailAddress = this.form.querySelector("input[name=email-address]");
        var helpText = this.form.querySelector("select[name=document-type]");
        var expiryDate = form.querySelector("input[name=date]");
        var idType = form.querySelector("input[name=idType]");
        var consent = form.querySelector("input[name=terms-and-conditions]");
        var termsConditionsCheck = (consent) ? consent.checked : '';
        var postData = {
            'firstName': (firstName ? firstName.value : ""),
            'surName': (surName ? surName.value : ""),
            'id': (id ? id.value : ""),
            'helpText': (helpText ? helpText.value : ""),
            'expiryDate': (expiryDate ? expiryDate.value : ""),
            'emailAddress': (emailAddress ? emailAddress.value : ""),
            'contact': (contact ? contact.value : ""),
            'idType': (idType ? idType.value : ""),
            'consent': ((termsConditionsCheck === true) ? "YES" : "NO")
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/services/PermitLeadsForm.jsp";
        // service
        this.formsService.postForm(url, this.http.serialiseObject(postData)).then(function (response) {
            if (response.data === "invalid") {
                _this.analyticsService.dtmFormComplete("complete", "false");
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                name.map(function (_item) {
                    _item.innerHTML = firstName.value;
                });
                _this.analyticsService.dtmFormComplete("complete", response.code);
                _this.showDisplayView("success");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemPermitRenewal.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayMessage.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "message":
                this.displayMessage.classList.remove("hidden");
                break;
            case "fields":
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayMessage.classList.remove("hidden");
                break;
        }
    };
    return FormItemPermitRenewal;
}(Base));
export { FormItemPermitRenewal };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-permit-renewal/form-item-permit-renewal.component.ts
// module id = 943
// module chunks = 0